import { Inject, Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Preferences as CapStorage } from '@capacitor/preferences';
import { LOCAL_STORAGE, SESSION_STORAGE } from '@ng-web-apis/common';

@Injectable({ providedIn: 'root' })
export class StorageService {
  constructor(@Inject(LOCAL_STORAGE) private localStorage: Storage) {}

  async get(key: string): Promise<string> {
    if (Capacitor.isNativePlatform()) {
      const s = await CapStorage.get({ key });
      return Promise.resolve(s.value);
    } else {
      return Promise.resolve(this.localStorage.getItem(key));
    }
  }

  set(key: string, value: string): Promise<void> {
    if (Capacitor.isNativePlatform()) {
      return CapStorage.set({ key, value });
    } else {
      return Promise.resolve(this.localStorage.setItem(key, value));
    }
  }

  clear() {
    if (Capacitor.isNativePlatform()) {
      return CapStorage.clear();
    } else {
      return Promise.resolve(this.localStorage.clear());
    }
  }

  remove(key: string) {
    if (Capacitor.isNativePlatform()) {
      return CapStorage.remove({ key });
    } else {
      return Promise.resolve(this.localStorage.removeItem(key));
    }
  }

  async info() {
    const storage: { [key: string]: string }[] = [];
    if (Capacitor.isNativePlatform()) {
      const keys = await CapStorage.keys();
      for (const key of keys.keys) {
        storage.push({ key, value: (await CapStorage.get({ key })).value });
      }
    } else {
      const str = await new Promise<{ [key: string]: string }[]>(resolve =>
        resolve(Object.entries(this.localStorage).map(([key, value]) => ({ [key]: value }))),
      );
      storage.push(...str);
    }
    console.log(storage);
  }
}
@Injectable({ providedIn: 'root' })
export class SessionStorageService {
  constructor(@Inject(SESSION_STORAGE) private sessionStorage: Storage) {}

  async get(key: string): Promise<string> {
    if (Capacitor.isNativePlatform()) {
      const s = await CapStorage.get({ key });
      return Promise.resolve(s.value);
    } else {
      return Promise.resolve(this.sessionStorage.getItem(key));
    }
  }

  set(key: string, value: string): Promise<void> {
    if (Capacitor.isNativePlatform()) {
      return CapStorage.set({ key, value });
    } else {
      return Promise.resolve(this.sessionStorage.setItem(key, value));
    }
  }

  clear() {
    if (Capacitor.isNativePlatform()) {
      return CapStorage.clear();
    } else {
      return Promise.resolve(this.sessionStorage.clear());
    }
  }

  remove(key: string) {
    if (Capacitor.isNativePlatform()) {
      return CapStorage.remove({ key });
    } else {
      return Promise.resolve(this.sessionStorage.removeItem(key));
    }
  }

  async info() {
    const storage: { [key: string]: string }[] = [];
    if (Capacitor.isNativePlatform()) {
      const keys = await CapStorage.keys();
      for (const key of keys.keys) {
        storage.push({ key, value: (await CapStorage.get({ key })).value });
      }
    } else {
      const str = await new Promise<{ [key: string]: string }[]>(resolve =>
        resolve(Object.entries(this.sessionStorage).map(([key, value]) => ({ [key]: value }))),
      );
      storage.push(...str);
    }
    console.log(storage);
  }
}
